import { ethers } from 'ethers';

// Detects available wallet provider (Trust, MetaMask, etc)
export const getProvider = () => {
  if (typeof window === 'undefined') return null;

  // Trust Wallet injects window.trustwallet.ethereum on some builds
  if (window.trustwallet?.ethereum) return window.trustwallet.ethereum;

  // Multi-provider case: EIP-1193 providers array
  if (window.ethereum?.providers?.length) {
    // Prefer Trust Wallet if present
    const trust = window.ethereum.providers.find((p) => p.isTrust || p.isTrustWallet);
    if (trust) return trust;
    // Otherwise MetaMask
    const mm = window.ethereum.providers.find((p) => p.isMetaMask);
    if (mm) return mm;
    return window.ethereum.providers[0];
  }

  return window.ethereum || null;
};

export const hasWallet = () => !!getProvider();

// Detect if user is on mobile
export const isMobile = () => {
  if (typeof navigator === 'undefined') return false;
  return /Android|iPhone|iPad|iPod|Opera Mini|IEMobile|Mobile/i.test(navigator.userAgent);
};

// Detect if inside a wallet's in-app browser
export const isInWalletBrowser = () => {
  const p = getProvider();
  return !!(p && (p.isTrust || p.isTrustWallet || p.isMetaMask || p.isCoinbaseWallet || p.isSafePal || p.isTokenPocket));
};

// Deep link to open dapp inside Trust Wallet browser
export const openInTrustWallet = () => {
  const url = window.location.href.replace(/^https?:\/\//, '');
  window.location.href = `https://link.trustwallet.com/open_url?coin_id=20000714&url=https://${url}`;
};

// Deep link to open dapp inside MetaMask browser
export const openInMetaMask = () => {
  const url = window.location.href.replace(/^https?:\/\//, '');
  window.location.href = `https://metamask.app.link/dapp/${url}`;
};

// Wrap a raw EIP-1193 provider into an ethers v5 Web3Provider
export const wrapEthers = (rawProvider) => new ethers.providers.Web3Provider(rawProvider, 'any');

export const shortenAddress = (address, chars = 4) => {
  if (!address) return '';
  return `${address.slice(0, 2 + chars)}...${address.slice(-chars)}`;
};
